import * as Yup from "yup";

export const BasicInformationValidate = Yup.object({
    first_name: Yup.string()
      .min(3, "Must be 3 charecters or more")
      .max(20, "Must be 20 characters or less")
      .required("Required"),
    last_name: Yup.string()
      .min(3, "Must be 3 charecters or more")
      .max(20, "Must be 20 characters or less")
      .required("Required"),
    gender: Yup.string().required("A option is required"),
    marital_status: Yup.string().required("A option is required"),
    personal_mail_id: Yup.string()
      .email("Enter valid Email")
      .required("Email is required"),
    personal_phone_number: Yup.string()
      .min(10, "Number must be at least 10 charaters")
      .required("Number is required"),
    dob: Yup.date()
      .nullable()
      .required("Date of Birth is required")
      .max(new Date(), "Date of Birth cannot be in the future")
      .test("dob-age", "You must be at least 18 years old", (value) => {
        if (!value) return false;
        const today = new Date();
        const birthDate = new Date(value);
        const age = today.getFullYear() - birthDate.getFullYear();
        const monthDiff = today.getMonth() - birthDate.getMonth();
        const dayDiff = today.getDate() - birthDate.getDate();
        return (
          age > 18 ||
          (age === 18 && (monthDiff > 0 || (monthDiff === 0 && dayDiff >= 0)))
        );
      }),
    nationality: Yup.string().required("Required"),
    // emergency_contact_name: Yup.string()
    //   .min(3, "Must be 3 charecters or more")
    //   .max(20, "Must be 20 characters or less")
    //   .required("Required"),
    // emergency_contact_relation: Yup.string()
    //   .min(3, "Must be 3 charecters or more")
    //   .max(20, "Must be 20 characters or less")
    //   .required("Required"),
    // emergency_contact_number: Yup.string()
    //   .min(10, "Number must be at least 10 charaters")
    //   .required("Number is required"),
    // emergency_contact_email: Yup.string()
    //   .email("Enter valid Email")
    //   .required("Email is required"),
  });